import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { AppTheme } from '@app/styles/theme';
import { rem } from '@app/styles/theme/layout';

import Card from '@app/components/Card';

import Radio from './Radio';

export const RadioBoxLabel = styled(Card.withComponent('label'))`
  margin-bottom: ${rem(15)};
  cursor: pointer;

  &:last-of-type {
    margin-bottom: 0;
  }

  &:active {
    box-shadow: none;
    transform: translateY(${rem(1)});
  }
`;

type RadioBoxRadioProps = {
  top?: boolean;
  outlineChecked?: boolean;
};

export const RadioBoxRadio = styled(Radio)<RadioBoxRadioProps>`
  ${({ outlineChecked, theme }) =>
    outlineChecked &&
    css`
      &:checked + ${RadioBoxLabel} {
        border: 1px solid ${(theme as AppTheme).colors.lightBlue};
      }
    `}

  &:checked + ${RadioBoxLabel}, &:not(:checked) + ${RadioBoxLabel} {
    display: flex;
    padding-left: ${rem(50)};
  }

  &:checked
    + ${RadioBoxLabel}::before,
    &:not(:checked)
    + ${RadioBoxLabel}::before {
    left: ${rem(20)};

    ${(props: RadioBoxRadioProps) =>
      props.top === true
        ? `margin-top: ${rem(25)}`
        : `top: 50%; margin-top: -${rem(10)};`}
  }

  &:checked
    + ${RadioBoxLabel}::after,
    &:not(:checked)
    + ${RadioBoxLabel}::after {
    left: ${rem(25)};

    ${(props: RadioBoxRadioProps) =>
      props.top === true
        ? `margin-top: ${rem(25)}`
        : `top: 50%; margin-top: -${rem(5)};`}
  }

  &:disabled + ${RadioBoxLabel} {
    opacity: 0.6;
    cursor: default;
  }
`;
